<div class="d-flex align-items-center justify-content-between">
  <h6 class="m-0">How would you rate the results?</h6>
  <div class="d-flex flex-row-reverse">
    @for (item of [5, 4, 3, 2, 1]; track $index) {
      <label class="cursor-pointer fa fa-star">
        <input
          type="checkbox"
          [ngModel]="rate === item"
          (ngModelChange)="rate = item"
          hidden />
      </label>
    }
  </div>
</div>
<textarea
  class="form-control"
  [(ngModel)]="comment"
  placeholder="Please share your experience"
  cdkTextareaAutosize
  cdkAutosizeMinRows="2"
  cdkAutosizeMaxRows="5"></textarea>
<p class="text-end m-0">
  @if (showSuccessMessage) {
    <strong class="text-success">Thank you!</strong>
  } @else if (rate || comment) {
    <button class="btn btn-primary btn-sm" (click)="onSubmit()">Submit</button>
  }
</p>
